module.exports = __webpack_public_path__ + "media/images/google-logo-cd0f2b3810415fc55809c6a4a78862e3.svg";